export default __webpack_public_path__ + "img/img1.4985c8e2.jpg";